import Pagination from '../vc-pagination/locale/bg_BG'
import DatePicker from '../date-picker/locale/bg_BG'
import TimePicker from '../time-picker/locale/bg_BG'
import Calendar from '../calendar/locale/bg_BG'

export default {
  locale: 'bg',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'Филтриране',
    filterConfirm: 'Добре',
    filterReset: 'Нулриане',
    emptyText: 'Няма данни',
    selectAll: 'Избор на текуща страница',
    selectInvert: 'Обръщане',
  },
  Modal: {
    okText: 'Добре',
    cancelText: 'Отказ',
    justOkText: 'Добре',
  },
  Popconfirm: {
    okText: 'Добре',
    cancelText: 'Отказ',
  },
  Transfer: {
    notFoundContent: 'Няма намерени',
    searchPlaceholder: 'Търсене',
    itemUnit: 'избор',
    itemsUnit: 'избори',
  },
  Select: {
    notFoundContent: 'Няма намерени',
  },
  Upload: {
    uploading: 'Качване...',
    removeFile: 'Премахване',
    uploadError: 'Грешка при качването',
    previewFile: 'Преглед',
  },
}



// WEBPACK FOOTER //
// ./components/locale-provider/bg_BG.js